import { render, staticRenderFns } from "./OfferItemCommissionList.vue?vue&type=template&id=38aeab12&"
import script from "./OfferItemCommissionList.vue?vue&type=script&lang=ts&"
export * from "./OfferItemCommissionList.vue?vue&type=script&lang=ts&"
import style0 from "./OfferItemCommissionList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports